//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import downloadApp from '@/components/downloadApp'
import api from "./api/api.js";
import WechatShare from "@/components/WechatShare";
export default {
  name: "app",
  components: { WechatShare,downloadApp},
  data() {
    return {
      isMarginShow:true,
      noReadTotal: 0,
      closeEvent:false,
      shareLogo: 'https://assets.aiyaopai.com/photoShcoolNew.png',
      options: {
        shareImgUrl: "",
        shareTitle: "",
        shareDescription: "",
        shareLink: "",
        screenHeight:0
      },
      userId:'',//当前登陆户的id
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      if(!this.closeEvent){
       if(to.name=='LoginPage'||to.name=='LoginPhone'||to.name=='CourseTypeDetailPage'||to.name=='VlogDetail'||to.name=='activityPage'||to.name=='CircleContent'||to.name=='CircleDetail'||to.name=='ArticleDetailPage'||to.name=='CourseDetailPage'||to.name=='personalHomePage'||to.name=='seriesDetail'||to.name=='votePage'){
         this.isMarginShow=false
       }else{
         this.isMarginShow=true
       }
      }
      next();
    });
  },
  beforeMount(){
     this.screenHeight= document.body.clientHeight ;
    //在登陆的情况下
    if (localStorage.getItem("Token") != null){
      //从token中获取userId
      let code = localStorage.getItem("Token").split('.')[1]
      // 解码base64数据,获取json格式的token值
      let needCode = JSON.parse(window.atob(code))
      this.userId=needCode.user_id
    }
  },
  mounted() {
    //给微信分享的信息赋值
    this.setShareInfo();
    ////刷新令牌
    //页面第一次加载时为防止令牌失效，要刷新令牌，先判断是否是登录状态（是否有token），如果是登录状态则调取刷新令牌的接口，成功则用获取新的令牌并替换旧令牌，存储在本地;刷新令牌不成功怎删除本地存储的token
    if (localStorage.getItem("Token") != null) {
      api.common
        .refreshToken(localStorage.getItem("Token"))
        .then(res => {
          if (res.status == 200) {
            //刷新令牌成功则用获取新的令牌并替换旧令牌，存储在本地
            localStorage.setItem("Token", res.data.Token);
            //调获取当前用户信息的接口,并将相应的信息存储全局vuex的store
            this.$store
              .dispatch("getCurrentUser")
              .then(res => {
                // App.vue中调取用户信息
              })
              .catch(res => {});
            // 刷新消息未读条数
            this.getNoticeList()
            this.getMessageComment()
            this.getMessageCall()
          }
        })
        .catch(res => {
          //当传入的旧令牌已经的过期时，则不能获取新的令牌进行替换，则刷新令牌失败，要清除之前的存储（好在相应的时间重新登陆）
          //刷新令牌失败，则清除本地存储
          localStorage.clear();
        });
    }
  },
  methods: {
    closeMarginEvent(){
      this.isMarginShow=false;
      this.closeEvent=true;
    },
    //获取通知列表
      getNoticeList() {
        api.article.getNoticeList(1, 50, "", false).then(res => {
          this.noReadTotal = this.noReadTotal + res.data.Total;
        });
      },
      //获取喜欢列表
      // getMessageLike() {
      //   api.article.getMessageLike(1, 50, "", false).then(res => {
      //     this.likeTotal = res.data.Total;
      //   });
      // },
      //获取评论列表
      getMessageComment() {
        api.article.getMessageComment(1, 50, "", false).then(res => {
          this.noReadTotal = this.noReadTotal + res.data.Total;
        });
      },
      //获取@我列表
      getMessageCall() {
        api.article.getMessageCall(1, 50, "", false).then(res => {
          this.noReadTotal = this.noReadTotal + res.data.Total;
        });
      },
    //除了文章和课程详情页，设置页面的title
    documentTitle() {
      if (
        this.$route.name != "ArticleDetailPage" &&
        this.$route.name != "CourseDetailPage"
      ) {
        //页面title赋值
        document.title = "在邀拍，发现你喜欢的摄影师";
      }
    },
    //给微信分享的信息赋值,后 初始化微信分享组件
    setShareInfo() {
      //文章详情页的分享信息赋值
      if (this.$route.name == "ArticleDetailPage") {
        api.article.getArticle(this.$route.params.articleId).then(res => {
          this.options.shareImgUrl = res.data.Cover;
          this.options.shareTitle = res.data.Title;
          this.options.shareLink = window.location.href;
          this.options.shareDescription =
            res.data.User.Nickname +
            "在邀拍发布了一篇新文章，快来看看吧。";
          this.$refs.wechatShare.init();
        });
      } else if (this.$route.name == "CourseDetailPage") {
        //课程详情页分享信息赋值
        api.course.getCourse(this.$route.params.courseId).then(res => {
          this.options.shareImgUrl = res.data.Cover;
          this.options.shareTitle = res.data.Title;
          this.options.shareLink = window.location.href;
          this.options.shareDescription = res.data.SubTitle;
          this.$refs.wechatShare.init();
        });
      }else if (this.$route.name == "CircleContent") {
        //圈子详情页分享信息赋值
        api.circle.GetTrendTag(this.$route.query.circleId).then(res => {
          this.options.shareImgUrl = res.data.Logo?res.data.Logo:res.data.Creator.Avatar;
          if(this.userId==res.data.Creator.Id){
            //分享自己的圈子
           this.options.shareTitle ='快来加入我的圈子#'+ res.data.Name+"，一起玩";
          }else{
            //分享别人的圈子
           this.options.shareTitle ='有趣的摄影内容尽在#'+ res.data.Name+"，强势围观一起玩";
          }      
          this.options.shareLink = window.location.href;
          this.options.shareDescription = res.data.Description?res.data.Description:'发现你喜欢的摄影师';
          this.$refs.wechatShare.init();
        });
      }else if (this.$route.name == "CircleDetail") {
        //动态详情页分享信息赋值
        api.circle.getCellCircle(this.$route.query.CircleId).then(res => {
          this.options.shareImgUrl = JSON.parse(`${res.data.Content}`)[0].uRL_Cover;
          this.options.shareTitle =(res.data.User.Role=='Photographer'?'摄影师':'')+res.data.User.Nickname+'发布了一条新的摄影动态，快来看看吧>>';
         if(this.$route.query.passIndex!=undefined){
            //预览大图的状态分享,处理一下分享链接不能是查看大图的状态
          this.options.shareLink = window.location.href.split('&')[0]
          }else{
          this.options.shareLink = window.location.href;
          }
          this.options.shareDescription = '发现你喜欢的摄影师';
          this.$refs.wechatShare.init();
        });

      }else if (this.$route.name == "VlogDetail") {
        //vlog详情页分享信息赋值
        api.circle.getCellCircle(this.$route.params.vlogId).then(res => {
          this.options.shareImgUrl = JSON.parse(`${res.data.Content}`)[0].uRL_Cover;
          this.options.shareTitle =(res.data.User.Role=='Photographer'?'摄影师':'')+res.data.User.Nickname+'的邀拍Vlog';
         if(this.$route.query.passIndex!=undefined){
            //预览大图的状态分享
          this.options.shareLink = window.location.href.split('&')[0]
          }else{
          this.options.shareLink = window.location.href;
          }
          this.options.shareDescription = '发现你喜欢的摄影师';
          this.$refs.wechatShare.init();
        });
      }else if (this.$route.name == "personalHomePage") {
        //个人主页分享信息赋值
        api.user.userGet(this.$route.params.personalId).then(res => {
          if(res.data.Id==this.$store.state.user.Info.Id){
            //分享用户自己的个人主页
            this.options.shareTitle =(res.data.Role=='Photographer'?'摄影师':'')+res.data.Nickname + " 与你分享了TA在邀拍的摄影故事，快来看看吧";
          }else{
            //其他人个人主页
            this.options.shareTitle =(res.data.Role=='Photographer'?'@摄影师':'@')+res.data.Nickname + " 在邀拍的摄影故事，快来看看吧";
          }
          this.options.shareImgUrl = res.data.Avatar;
          this.options.shareLink = window.location.href;
          this.options.shareDescription ="喜欢加个关注呀";
          this.$refs.wechatShare.init();
        });
      }else if(this.$route.name == "locatonDetail"){
        //打卡地详情页
        api.location.getTrendLocation(this.$route.params.locationId).then(res=>{
          this.options.shareTitle =(this.$store.state.user.Info.Nickname?`@摄影师${this.$store.state.user.Info.Nickname}`:'@邀拍用户')+' 向你推荐了拍照好去处|'+res.data.Name+'，快来看看吧';
          this.options.shareLink = window.location.href;
          this.options.shareImgUrl = res.data.Logo;
          this.options.shareDescription ="一起解锁城市之美";
          this.$refs.wechatShare.init();
        })
      }else if(this.$route.name == "seriesDetail"){
        //套系详情页
        api.location.getSeriesDetail(this.$route.params.seriesId).then(res=>{
          this.options.shareTitle ='来邀拍必拍套系《'+res.data.Name+'》快来看看吧'
          this.options.shareDescription ="点击预约拍摄";
          this.options.shareLink = window.location.href;
          this.options.shareImgUrl = res.data.Cover;
          this.$refs.wechatShare.init();
        })
        
      }else {
        //其他页面分享信息赋值
        this.options.shareImgUrl = this.shareLogo;
        this.options.shareTitle = "发现你喜欢的摄影师";
        this.options.shareDescription =
          "摄影大咖都在这里，他们邀请你来 邀拍 一起学习交流摄影知识";
        //如果是首页的推荐／关注／课程列表页／文章列表页／圈子列表页分享地址也为该页面
        if (
          this.$route.name == "RecommendView"||this.$route.name == "ConcernView"
        ) {
          this.options.shareLink = window.location.href;
        } else {
          //除以上列出的页面分享其他的所有页面分享都为首页推荐页
          this.options.shareLink = window.location.origin + "/";
        }
        this.$refs.wechatShare.init();
      }
    }
  },
  computed: {
    routerPath() {
      if (this.$route.name == "CircleContent") {
        //圈子详情页
        return "CircleContent";
      }else if (this.$route.name == "CircleDetail") {
        //动态详情页
        return "CircleDetail";
      }
      else if (this.$route.name == "ArticleDetailPage") {
        //文章详情页
        return "ArticleDetailPage";
      } else if (this.$route.name == "CourseDetailPage") {
        //课程详情页
        return "CourseDetailPage";
      } else if (this.$route.name == "personalHomePage") {
        //个人主页
        return "personalHomePage";
      } else if (this.$route.name == "AllLearnView") {
        //课程列表页
        return "AllLearnView";
      } else if (this.$route.name == "ArticleView") {
        //文章列表页
        return "ArticleView";
      }else if (this.$route.name == "ConcernView") {
        //首页中的关注页
        return "ConcernView";
      }
      else if (this.$route.name == "RecommendView") {
        //首页中的推荐页
        return "RecommendView";
      }
      else if (this.$route.name == "VlogView") {
        //首页中的VlogView页
        return "VlogView";
      }
      else if (this.$route.name == "CircleView") {
        //圈子列表页
        return "CircleView";
      }else if (this.$route.name == "VlogDetail") {
        //Vlog详情页
        return "VlogDetail";
      }else if(this.$route.name == "locatonDetail"){
        //打卡地详情页
        return 'locatonDetail'
      }else if(this.$route.name == "seriesDetail"){
        //套系详情页
        return 'seriesDetail' 
      }
       else {
        return "/";
      }
    }
  },
  watch: {
    $route:{
      deep:true,
      handler(newV,oldV){
       if(newV.name=='LoginPage'||newV.name=='LoginPhone'||newV.name=='CourseTypeDetailPage'||newV.name=='VlogDetail'||newV.name=='activityPage'||newV.name=='CircleContent'||newV.name=='CircleDetail'||newV.name=='ArticleDetailPage'||newV.name=='CourseDetailPage'||newV.name=='personalHomePage'||newV.name=='seriesDetail'||newV.name=='votePage'){
         this.isMarginShow=false
       }else{
         this.isMarginShow=true
       }

      }
    },
    routerPath() {
      //给微信分享的信息赋值
      this.setShareInfo();
      //除了文章和课程详情页，设置页面的title
      this.documentTitle();
    },
    noReadTotal: function(newdata) {
      this.$store.commit('noReadTotal', newdata)
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue